import { render, staticRenderFns } from "./aboutPartner.vue?vue&type=template&id=48baeed4&"
import script from "./aboutPartner.vue?vue&type=script&lang=js&"
export * from "./aboutPartner.vue?vue&type=script&lang=js&"
import style0 from "./aboutPartner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports